export const numberWithComas = x => {
	return typeof x !== "undefined" && !isNaN(x)
		? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " đ"
		: null;
};

export const getMobileOperatingSystem = () => {
	var userAgent = navigator.userAgent || navigator.vendor || window.opera;

	// Windows Phone must come first because its UA also contains "Android"
	if (/windows phone/i.test(userAgent)) {
		return "Windows Phone";
	}

	if (/android/i.test(userAgent)) {
		return "Android";
	}

	// iOS detection from: http://stackoverflow.com/a/9039885/177710
	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
		return "iOS";
	}

	return "unknown";
};

export const validateEmail = (email = "") => {
	const re =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
};

export const clearListPromotionCode = () => {
	localStorage.setItem("listPromotionCode", JSON.stringify([]));
};

// check product is on cart
export const initProductIds = ids => {
	clearProductIds();
	localStorage.setItem("productIds", JSON.stringify([...ids]));
};

export const addProductIds = productId => {
	let productIds = [];
	const list = getProductIds();
	if (list === undefined) {
		localStorage.setItem("productIds", JSON.stringify([productId]));
	} else {
		const ids = list.filter(id => id == productId);
		if (ids.length === 0) {
			productIds = [...list, productId];
			clearProductIds();
			localStorage.setItem("productIds", JSON.stringify(productIds));
		}
	}
};

export const getProductIds = () => {
	const cached = JSON.parse(localStorage.getItem("productIds"));
	if (cached && Array.isArray(cached) && cached.length > 0) {
		return cached;
	}
	return undefined;
};

export const removeProductById = productId => {
	let productIds = getProductIds();
	if (productIds !== undefined && productIds.length > 0) {
		clearProductIds();
		localStorage.setItem(
			"productIds",
			JSON.stringify(productIds.filter(id => id != productId))
		);
	}
};

export const clearProductIds = () => {
	localStorage.removeItem("productIds");
};

export const checkIsLogged = () => {
	const sid = localStorage.getItem("SID");
	if (sid != null && sid[0] != "-") {
		return true;
	}
	return false;
};

export const getIsSkip = () => {
	return !localStorage.getItem("isSkipChangePassword") ||
		localStorage.getItem("isSkipChangePassword") === "false"
		? false
		: true;
};

export const infoOpacity = (heightScroll, height) => {
	const opacity = heightScroll / height;
	return opacity < 1 ? opacity : 1;
};

export const configDataProduct = (products, carts) => {
	return products.map(item => {
		let index = carts.findIndex(order => order.id === item.id);
		if (index > -1) {
			return { ...item, isSelected: true };
		} else {
			return { ...item, isSelected: false };
		}
	});
};

export const getUniqueProductIds = products => {
	const uniqueProductIds = new Set();
	const uniqueProducts = [];
	for (const product of products) {
		if (!uniqueProductIds.has(product.id)) {
			uniqueProducts.push(product);
			uniqueProductIds.add(product.id);
		}
	}
	return uniqueProducts;
};
